import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Modal } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

export default function PortalDialog({
  open,
  onClose,
  title,
  disableClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  disableClose?: boolean;
  children?: React.ReactNode;
}) {
  const handleClose = () => {
    if (disableClose) {
      return;
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <>
        <Box
          sx={{
            outline: "none",
            "&:focus-visible": { outline: "none" },
            bgcolor: "var(--color-zinc-800)",
            boxShadow: "0 0 0 4px rgba(0,0,0,0.5)",
            width: "auto",
            minWidth: "320px",
            "@media (min-width: 768px)": { minWidth: "448px" },
            p: 2,
            borderRadius: 2,
            maxWidth: "calc(100vw - 8rem)",
          }}
        >
          {(!disableClose || title) && (
            <Box sx={{ display: "flex", mb: 2, alignItems: "center", gap: 1 }}>
              {title && <Box sx={{ fontSize: "1.5rem", fontWeight: 700, flexGrow: 1 }}>{title}</Box>}
              {!disableClose && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    ...(!title && { flexGrow: 1 }),
                  }}
                >
                  <IconButton size="small" aria-label="close" color="primary" onClick={onClose}>
                    <CloseIcon role="img" />
                  </IconButton>
                </Box>
              )}
            </Box>
          )}
          <Box sx={{ overflowY: "auto", maxHeight: "calc(100vh - 8rem)" }}>
            <Box>{children}</Box>
          </Box>
        </Box>
      </>
    </Modal>
  );
}
